import React, { useEffect } from 'react';
import AllCoursesSection from './AllCourseSection';
import ScrollToTop from '../../components/Common/ScrollTop';


const AllCourseMain = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <React.Fragment>

            {/* CoursePart Start */}
            <AllCoursesSection />
            {/* CoursePart End */}

			{/* scrolltop-start */}
			<ScrollToTop
				scrollClassName="scrollup orange-color"
			/>
			{/* scrolltop-end */}

        </React.Fragment>
    )
}

export default AllCourseMain;